<template>
  <!-- 用户信息修改 -->
  <h3 class="mt-3">{{ profiletitle }}</h3>

  <el-form
    :model="userinfoobj"
    :rules="userinforules"
    :ref="setuserinforuleFormRef"
  >
    <!-- name -->
    <el-row justify="center" class="mt-3">
      <el-col :span="9"
        ><p class="utitle">{{ $t("editprofilemessage.firstname") }}</p></el-col
      >
      <el-col :span="1"></el-col>
      <el-col :span="9"
        ><p class="utitle">{{ $t("editprofilemessage.lastname") }}</p></el-col
      >
    </el-row>
    <el-row
      justify="center"
      :class="[firstname == '' && lastname == '' ? 'mt-3' : 'mt-0']"
    >
      <el-col :span="9">
        <el-form-item prop="firstname"
          ><el-input
            v-model="userinfoobj.firstname"
            :placeholder="$t('editprofilemessage.firstname')"
            clearable/></el-form-item
      ></el-col>
      <el-col :span="1"
        ><div class="mx-2" style="float: left; color: red"></div
      ></el-col>
      <el-col :span="8"
        ><el-form-item prop="lastname"
          ><el-input
            v-model="userinfoobj.lastname"
            :placeholder="$t('editprofilemessage.lastname')"
            clearable/></el-form-item
      ></el-col>
      <el-col :span="1"
        ><div class="mx-2" style="float: left; color: red"></div
      ></el-col>
    </el-row>

    <!-- 公司 -->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">{{ $t("editprofilemessage.company") }}</p></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>

    <el-row
      justify="center"
      align="middle"
      :class="[company == '' ? 'mt-3' : 'mt-0']"
    >
      <el-col :span="9">
        <el-form-item>
          <el-input
            id="tuiguangcompany"
            v-model="userinfoobj.company"
            :placeholder="$t('editprofilemessage.company')"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="9"></el-col>
    </el-row>

    <!-- 电子邮件 -->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">{{ $t("editprofilemessage.email") }}</p></el-col
      >
      <el-col :span="1"></el-col>
      <el-col :span="9"
        ><p class="utitle">
          {{ $t("editprofilemessage.confirmemail") }}
        </p></el-col
      >
    </el-row>
    <el-row justify="center" class="mt-0">
      <el-col :span="9">
        <el-form-item prop="email"
          ><el-input
            v-model="userinfoobj.email"
            type="email"
            placeholder="Email"
            clearable/></el-form-item
      ></el-col>
      <el-col :span="1"></el-col>
      <el-col :span="9"
        ><el-form-item prop="confirmemail"
          ><el-input
            v-model="userinfoobj.confirmemail"
            type="email"
            :placeholder="$t('editprofilemessage.confirmemail')"
            clearable/></el-form-item
      ></el-col>
    </el-row>

    <!-- 领域 -->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">
          {{ $t("editprofilemessage.selectdomain") }}
        </p></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center" class="mt-0">
      <el-col :span="9">
        <el-select
          v-model="userinfoobj.selecteddomain"
          :placeholder="$t('editprofilemessage.selectdomain')"
          style="display: block"
        >
          <el-option
            v-for="item in domain"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center">
      <el-col :span="9"
        ><div v-if="domainempty" class="sfont">Domain empty</div></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>

    <!-- 教育程度 -->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">
          {{ $t("editprofilemessage.selecteducation") }}
        </p></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center" class="mt-0">
      <el-col :span="9">
        <el-select
          v-model="selectededucation"
          placeholder="Education"
          style="display: block"
        >
          <el-option
            v-for="item in education"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>

    <!-- 职业-->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">
          {{ $t("editprofilemessage.selectoccupation") }}
        </p></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center" class="mt-0">
      <el-col :span="9">
        <el-select
          v-model="selectedoccupation"
          placeholder="Occupation"
          style="display: block"
        >
          <el-option
            v-for="item in occupation"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>

    <!-- 用途 -->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">
          {{ $t("editprofilemessage.selectusage") }}
        </p></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center" class="mt-0">
      <el-col :span="9">
        <el-select
          v-model="selectedusage"
          placeholder="Select Usage"
          style="display: block"
        >
          <el-option
            v-for="item in usage"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>
    

    <!-- 国别 -->
    <el-row justify="center" class="mt-4">
      <el-col :span="9"
        ><p class="utitle">
          {{ $t("editprofilemessage.selectcountry") }}
        </p></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center" class="mt-0">
      <el-col :span="9">
        <el-select
          v-model="selectedcountry"
          placeholder="Select Your Country"
          style="display: block"
        >
          <el-option
            v-for="item in country"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>
    <el-row justify="center">
      <el-col :span="9"
        ><div v-if="countryempty" class="sfont">Country empty</div></el-col
      >
      <el-col :span="10"></el-col>
    </el-row>

    <el-row justify="end" class="mt-2">
      <el-col :span="2"></el-col>
      <el-col :span="5">
        <el-button class="mb-5" type="primary" @click="onchangeprofile">{{
          $t("editprofilemessage.savemodification")
        }}</el-button>
      </el-col>
    </el-row>
  </el-form>

  <!-- 修改密码 -->
  <el-row justify="center" class="mb-5"
    ><h3>{{ $t("editprofilemessage.changepasswd") }}</h3></el-row
  >
  <el-row justify="center" class="mt-1">
    <el-col :span="19">
      <p style="float: left">
        {{ $t("editprofilemessage.passwdrule1") }}
      </p>
    </el-col>
  </el-row>
  <el-row justify="center" class="mt-1">
    <el-col :span="19">
      <p style="float: left">{{ $t("editprofilemessage.passwdrule2") }}</p>
    </el-col>
  </el-row>

  <el-form :model="passwdobj" :rules="rules" :ref="setruleFormRef">
    <el-row justify="center" class="mt-4">
      <el-col :span="9">
        <el-form-item prop="oldpasswd">
          <el-input
            type="password"
            :placeholder="$t('editprofilemessage.oldpasswd')"
            v-model="passwdobj.oldpasswd"
            clearable
          />
        </el-form-item>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>

    <el-row justify="center" class="mt-3">
      <el-col :span="9">
        <el-form-item prop="newpasswd">
          <el-input
            v-model="passwdobj.newpasswd"
            type="password"
            :placeholder="$t('editprofilemessage.passwd')"
            clearable/></el-form-item
      ></el-col>
      <el-col :span="1"></el-col>
      <el-col :span="9"
        ><el-form-item prop="confirmpasswd">
          <el-input
            v-model="passwdobj.confirmpasswd"
            type="password"
            :placeholder="$t('editprofilemessage.confirmpasswd')"
            clearable
            @blur="onconfirmpasswd"/></el-form-item
      ></el-col>
    </el-row>
  </el-form>

  <el-row justify="end" class="mt-2">
    <el-col :span="2"></el-col>
    <el-col :span="5">
      <el-button class="mt-3 mb-5" type="primary" @click="onchangepasswd()">{{
        $t("editprofilemessage.changepasswd")
      }}</el-button>
    </el-col>
  </el-row>
</template>

<script>
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  toRefs,
  computed,
} from "vue";
import { useI18n } from "vue-i18n";
//import { FormInstance } from "element-plus";

import { des } from "../../js/des";
import {
  changepassword,
  getuserprofile,
  changeprofile,
} from "../../js/userhandler";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    //#region 变量
    const ruleFormRef = ref(null);
    const ruleuserFormRef = ref(null);
    const { t } = useI18n();
    const passwdobj = reactive({
      oldpasswd: "",
      newpasswd: "",
      confirmpasswd: "",
    });
    const userinfoobj = reactive({
      firstname: "",
      lastname: "",
      company: "",
      email: "",
      confirmemail: "",
      username: "",
      selecteddomain: "",
      selectedcountry: "",
      selectedusage: "",
      selectededucation: "",
      selectedoccupation: "",
    });

    const router = useRouter();
    onMounted(() => {
      //注册事件
      try {
        getuserprofile().then((res) => {
          if (res.status == 200) {
            if (res.data.status === "0") {
              console.log("get userprofile failed");
              router.push("querymap");
            } else {
              //userinfoobj.value = res.data.userprofile;
              userinfoobj.firstname = res.data.userprofile.firstname;
              userinfoobj.lastname = res.data.userprofile.lastname;
              userinfoobj.company = res.data.userprofile.company;
              userinfoobj.username = res.data.userprofile.username;
              userinfoobj.email = res.data.userprofile.email;
              userinfoobj.selecteddomain = res.data.userprofile.domain;
              userinfoobj.selectedcountry = res.data.userprofile.country;
              userinfoobj.selectedusage = res.data.userprofile.usage;
              userinfoobj.selectededucation = res.data.userprofile.education;
              userinfoobj.selectedoccupation = res.data.userprofile.occupation;
            }
          } else console.log("Serve error");
        });
      } catch (error) {
        console.log(error);
      }
    });

    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(t("editprofilemessage.passwordalerm1")));
      } else if (value.length < 8)
        callback(new Error(t("editprofilemessage.passwordalerm2")));
      else {
        if (passwdobj.confirmpasswd !== "") {
          if (!ruleFormRef.value) return;
          ruleFormRef.value.validateField("confirmpasswd", () => null);
        }
        callback();
      }
    };

    const profiletitle = computed(() => {
      var title = t("editprofilemessage.title", {
        username: userinfoobj.username,
      });
      return title;
    });

    const validateconfirmPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== passwdobj.newpasswd) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };

    function ValidateEmail(rule, value, callback) {
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (value === "" || !value.match(mailformat)) {
        callback(new Error("Please input a valid email"));
      } else if (userinfoobj.confirmemail != "") {
        ruleuserFormRef.value.validateField("confirmemail", () => null);
      }
      callback();
    }

    function ValidateconfirmEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input a valid email"));
      } else if (value !== userinfoobj.email) {
        callback(new Error("E-mail doesn't match!"));
      } else {
        callback();
      }
    }

    const userinforules = reactive({
      firstname: [
        {
          required: true,
          message: t("editprofilemessage.firstnameempty"),
        },
      ],
      lastname: [
        {
          required: true,
          message: t("editprofilemessage.lastnameempty"),
        },
      ],
      email: [
        {
          validator: ValidateEmail,
          trigger: "blur",
        },
      ],
      confirmemail: [
        {
          validator: ValidateconfirmEmail,
          trigger: "blur",
        },
      ],
    });
    //密码规则
    const rules = reactive({
      oldpasswd: [
        {
          required: true,
          message: "Please input old password",
          trigger: "blur",
        },
      ],
      newpasswd: [
        {
          validator: validatePass,
          trigger: "blur",
        },
      ],
      confirmpasswd: [
        {
          validator: validateconfirmPass,
          trigger: "blur",
        },
      ],
    });

    const domain = [
      { value: "Agriculture Science", label: "Agriculture Science" },
      { value: "Forest Science", label: "Forest Science" },
      { value: "Water resources", label: "Water resources" },
      { value: "Disaster management", label: "Disaster management" },
      { value: "Biodiversity", label: "Biodiversity" },
      {
        value: "Geographic Information System（GIS）",
        label: "Geographic Information System（GIS）",
      },
      { value: "Geology", label: "Geology" },
      { value: "Atmospheric Science", label: "Atmospheric Science" },
      { value: "Marine Science", label: "Marine Science" },
      { value: "Computer Science", label: "Computer Science" },
      { value: "Others", label: "Others" },
    ];
    const usage = [
      {
        value: "Research",
        label: "Research",
      },
      {
        value: "Commercial",
        label: "Commercial",
      },
      {
        value: "Education",
        label: "Education",
      },
      {
        value: "Other",
        label: "Other",
      },
    ];
    const country = [
      "Afghanistan",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Arctic Ocean",
      "Argentina",
      "Armenia",
      "Aruba",
      "Ashmore and Cartier Islands",
      "Atlantic Ocean",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Baltic Sea",
      "Baker Island",
      "Bangladesh",
      "Barbados",
      "Bassas da India",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Borneo",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Clipperton Island",
      "Cocos Islands",
      "Colombia",
      "Comoros",
      "Cook Islands",
      "Coral Sea Islands",
      "Costa Rica",
      "Cote d Ivoire",
      "Croatia",
      "Cuba",
      "Curacao",
      "Cyprus",
      "Czech Republic",
      "Democratic Republic of the Congo",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Europa Island",
      "Falkland Islands (Islas Malvinas)",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern and Antarctic Lands",
      "Gabon",
      "Gambia",
      "Gaza Strip",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Glorioso Islands",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and McDonald Islands",
      "Honduras",
      "Hong Kong",
      "Howland Island",
      "Hungary",
      "Iceland",
      "India",
      "Indian Ocean",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Jan Mayen",
      "Japan",
      "Jarvis Island",
      "Jersey",
      "Johnston Atoll",
      "Jordan",
      "Juan de Nova Island",
      "Kazakhstan",
      "Kenya",
      "Kerguelen Archipelago",
      "Kingman Reef",
      "Kiribati",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Line Islands",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mediterranean Sea",
      "Mexico",
      "Micronesia, Federated States of",
      "Midway Islands",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Navassa Island",
      "Nepal",
      "Netherlands",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "North Korea",
      "North Macedonia",
      "North Sea",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pacific Ocean",
      "Pakistan",
      "Palau",
      "Palmyra Atoll",
      "Panama",
      "Papua New Guinea",
      "Paracel Islands",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn Islands",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Republic of the Congo",
      "Reunion",
      "Romania",
      "Ross Sea",
      "Russia",
      "Rwanda",
      "Saint Barthelemy",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Martin",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Sint Maarten",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "South Korea",
      "South Sudan",
      "Southern Ocean",
      "Spain",
      "Spratly Islands",
      "Sri Lanka",
      "State of Palestine",
      "Sudan",
      "Suriname",
      "Svalbard",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan,China",
      "Tajikistan",
      "Tanzania",
      "Tasman Sea",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tromelin Island",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "Uruguay",
      "USA",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Virgin Islands",
      "Wake Island",
      "Wallis and Futuna",
      "West Bank",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ];
    const education = [
      {
        value: "Student in School",
        label: "Student in School",
      },
      {
        value: "Undergraduate",
        label: "Undergraduate",
      },
      {
        value: "Master",
        label: "Master",
      },
      {
        value: "Doctor",
        label: "Doctor",
      },
      {
        value: "Post-doctor",
        label: "Post-doctor",
      },
      {
        value: "Others",
        label: "Others",
      },
    ];
    const occupation = [
      {
        value: "IT / Computer professionals",
        label: "IT / Computer professionals",
      },
      {
        value: "University professors and teachers ",
        label: "University professors and teachers ",
      },
      {
        value: "Engineers ",
        label: "Engineers ",
      },
      {
        value: "Scientists",
        label: "Scientists",
      },

      {
        value: "Market research analysts",
        label: "Market research analysts",
      },
      {
        value: "Teachers in elementary or secondary schools, colleges",
        label: "Teachers in elementary or secondary schools, colleges",
      },
      {
        value: "Students",
        label: "Students",
      },
      {
        value: "Others",
        label: "Others",
      },
    ];

    //#endregion

    //提交用户修改
    const onchangeprofile = async () => {
      await ruleuserFormRef.value.validate((valid, fields) => {
        if (valid) {
          let params = {};
          params.firstname = userinfoobj.firstname;
          params.lastname = userinfoobj.lastname;
          params.country = userinfoobj.selectedcountry;
          params.usage = userinfoobj.selectedusage;
          params.domain = userinfoobj.selecteddomain;
          params.email = userinfoobj.email;
          params.company = userinfoobj.company;
          params.education = userinfoobj.selectededucation;
          params.occupation = userinfoobj.selectedoccupation;
          changeprofile(params).then((res) => {
            if (res.status == "200") {
              if (res.data.status == "1") alert("profile changed");
              else alert("profile changed failed");
            }
          });
        } else {
          console.log(fields);
          return false;
        }
      });
    };

    const onchangepasswd = async () => {
      await ruleFormRef.value.validate((valid) => {
        if (valid) {
          let npasswd = des("tuiguang", passwdobj.newpasswd, 1, 0);
          let opasswd = des("tuiguang", passwdobj.oldpasswd, 1, 0);
          changepassword(opasswd, npasswd).then((res) => {
            if (res.status == 200) {
              if (res.data.status == "1") {
                ruleFormRef.value.resetFields();
                alert("passwd changed");
              } else {
                alert("Old password you entered don't match ");
              }
            }
          });
        }
      });
    };

    //获取密码form的引用
    const setruleFormRef = (el) => {
      ruleFormRef.value = el;
    };
    const setuserinforuleFormRef = (el) => {
      ruleuserFormRef.value = el;
    };

    return {
      setruleFormRef,
      setuserinforuleFormRef,
      domain,
      usage,
      country,
      education,
      occupation,
      rules,
      userinforules,
      passwdobj,
      userinfoobj,
      onchangepasswd,
      onchangeprofile,
      profiletitle,
      ...toRefs(userinfoobj),
    };
  },
});
</script>

<style scoped>
.sfont {
  color: rgb(255, 102, 0);
  font-size: 0.65em;
}
.utitle {
  float: left;
  color: gray;
  font-size: 0.65em;

  margin-bottom: 0.1em;
}
</style>
